function TextInput({
  classWrap,
  className,
  id,
  type,
  name,
  placeholder,
  autocomplete,
  required,
  value,
  confirm,
  confirmMessage,
  onInput = () => {},
  onBlur = () => {},
  labelInputClass,
  showSymbol = true
}) {
  const wrapperClass = classWrap ? `relative ${classWrap}` : 'relative'
  const inputClass = className ? `peer input no-autocomplete ${className}` : 'peer input no-autocomplete'
  const getDateLocal = ({ limitMonths = 0 } = {}) => {
    const d = new Date()

    if (limitMonths) d.setMonth(d.getMonth() + limitMonths)

    const pad = (n) => String(n).padStart(2, '0')
    const yyyy = d.getFullYear()
    const mm = pad(d.getMonth() + 1)
    const dd = pad(d.getDate())

    return `${yyyy}-${mm}-${dd}`
  }

  return (
    <div className={wrapperClass}>
      <input
        className={inputClass}
        id={id}
        type={type}
        name={name}
        aria-label={placeholder}
        placeholder={placeholder}
        autoComplete={autocomplete}
        required={required}
        value={value}
        data-confirm={confirm}
        data-confirm-message={confirmMessage}
        onInput={onInput}
        onBlur={onBlur}
        min={type === 'date' ? getDateLocal() : null}
        max={type === 'date' ? getDateLocal({ limitMonths: 1 }) : null}
      />
      <label className={`input-label ${labelInputClass}`} htmlFor={id}>
        {placeholder}
        {required && showSymbol && '*'}
      </label>
    </div>
  )
}

export default TextInput
